import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M2.83333 0.5C1.54467 0.5 0.5 1.54467 0.5 2.83333V14.5C0.5 15.7887 1.54467 16.8333 2.83333 16.8333H14.5C15.7887 16.8333 16.8333 15.7887 16.8333 14.5V2.83333C16.8333 1.54467 15.7887 0.5 14.5 0.5H2.83333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M5.16667 19.1667C4.52233 19.1667 4 19.689 4 20.3333C4 20.9777 4.52233 21.5 5.16667 21.5H18C19.933 21.5 21.5 19.933 21.5 18V5.16667C21.5 4.52234 20.9777 4 20.3333 4C19.689 4 19.1667 4.52234 19.1667 5.16667V18C19.1667 18.6443 18.6443 19.1667 18 19.1667H5.16667Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}